import { Type } from '@angular/core';
import { FilterDefaultOptions } from '@iot-platform/models/common';
import { AbstractUserPreferencesFavoriteFilterEngineService } from '../services/abstract-user-preferences-favorite-filter-engine.service';

export type FilterEngineOptions = {
  [concept: string]: { [category: string]: { [key: string]: FilterDefaultOptions } };
};

export class FilterEngineSettings {
  userPreferencesService!: Type<AbstractUserPreferencesFavoriteFilterEngineService>;
  options!: FilterEngineOptions;
}
